import React, { useState } from 'react';
import { Link, NavLink } from 'react-router-dom';

const navItems = [
  { name: 'Home', href: '/' },
  { name: 'About', href: '/about' },
  { name: 'Services', href: '/services' },
  { name: 'Analytics', href: '/analytics' },
  { name: 'FAQ', href: '/faq' },
  { name: 'Contact Us', href: '/contact' },
];

const NavbarComponent = () => {
  const [isMenuOpen, setIsMenuOpen] = useState(false);


  return (
    <nav className="custom-navbar">
      <div className="navbar-container">
        <div className="navbar-logo">
          <Link to="/">
            <img
              src={process.env.PUBLIC_URL + '/logo_1.png'}
              alt="Logo"
              height="80"
              className="d-inline-block align-top"
            />
          </Link>
        </div>
        {/* Hamburger Icon */}
        <div className={`navbar-toggle${isMenuOpen ? ' active' : ''}`} onClick={() => setIsMenuOpen(!isMenuOpen)}>
          <span className="bar"></span>
          <span className="bar"></span>
          <span className="bar"></span>
        </div>
        {/* Menu Items */}
        <ul className={`navbar-menu${isMenuOpen ? ' active' : ''}`}>
          {navItems.map((item) => (
            <li className="navbar-item" key={item.name}>
              {item.href.startsWith('/') ? (
                <NavLink 
                  className={({ isActive }) => isActive ? "navbar-link active" : "navbar-link"} 
                  to={item.href} 
                  onClick={() => setIsMenuOpen(false)}
                  end={item.href === '/'}
                >
                  {item.name}
                </NavLink>
              ) : (
                <span className="navbar-link">{item.name}</span>
              )}
            </li>
          ))}
        </ul>
      </div>
    </nav>
  );
};

export default NavbarComponent;
